import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box } from '@mui/material'
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { trackActivity } from '../../../../utils/mixpanel'

const LgGroupingCofirmModal = ({ lgGrouping, onToggleModal, getResponseBack, isLoading }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `LG Grouping Modal`, page_type: page_type, })
    }
    return (
        <Dialog aria-labelledby="customized-dilog-title" className="add-lease-dialog" PaperProps={{
            sx: {
                width: 700,
                fontFamily:"Roboto",
                maxWidth: "90vw",
            }
        }} fullWidth open={lgGrouping.modal} >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='dialog-header' style={{fontSize:"17px"}}> Enable Landing Gear Grouping? </DialogTitle>
            <DialogContent dividers >
                <Typography className='lg-header' > Changing the LG Grouping setting will affect the following modules for this lease: </Typography>
                <Box component="ul" sx={{ mt: 0.6 }} >
                    <li> <span className='lg-header'>Reserve Rates</span>  <span style={{fontSize:"14px", fontFamily:"Roboto"}}> - Set one rate for all LGs and define how amounts are split across each gear.</span>   </li>
                    <li> <span className='lg-header'>Utilization</span> <span style={{fontSize:"14px" ,fontFamily:"Roboto"}}> - Enter flight data once; SPARTA automatically applies it to LG1, LG2, and LG3.</span> </li>
                    <li> <span className='lg-header'>Invoices</span> <span style={{fontSize:"14px", fontFamily:"Roboto"}}> - One line item appears on the invoice; amounts are distributed to each LG <span style={{marginLeft :"68px"}}>internally by % split.</span></span> </li>
                </Box>
                <Box className="warning-text" sx={{ display: "flex", alignItems: "center", gap: 1, p: 0.8 }}><WarningAmberIcon sx={{ fontSize: 16, color: "#a78701" }} /> <Box>
                    This change applies to future records only.Existing utilization and invoice records are not affected.
                    <br />
                    <Box sx={{ mt:0.3 }}>
  If an LG is linked or unlinked for an MSN, the existing records will continue to display data based on the previously mapped LGs to maintain historical tracking.
  If the user creates a new record, then the data will be displayed based on the latest linked/unlinked LG configuration.
</Box>
                </Box></Box>
            </DialogContent>
            <DialogActions sx={{ marginRight: "15px" }}>
                <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>Cancel</Button>
                <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); getResponseBack(true); }}> {isLoading ? <CircularProgress color='inherit' size={24} /> : "Enable LG Grouping"} </Button>
            </DialogActions>
        </Dialog>
    )
}

export default LgGroupingCofirmModal

//     Dialog,
//     DialogActions,
//     DialogContent,
//     DialogTitle,
//     Box,
//     Typography,
// } from "@mui/material";
// import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
// import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
// import { trackActivity } from "../../../../utils/mixpanel";

// const LgGroupingCofirmModal = ({
//     lgGrouping,
//     onToggleModal,
//     getResponseBack,
//     isLoading,
// }) => {
//     const handleItemClicked = (page_type) => {
//         trackActivity("Item Clicked", {
//             page_title: `LG Grouping Modal`,
//             page_type: page_type,
//         });
//     };

//     return (
//         <Dialog
//             open={lgGrouping.modal}
//             maxWidth="md"
//             fullWidth
//             onClose={onToggleModal}
//             PaperProps={{
//                 sx: {
//                     borderRadius: "24px",
//                     overflow: "hidden",
//                 },
//             }}
//         >
//             {/* Header */}
//             <DialogTitle
//                 sx={{
//                     background: "#1f4474",
//                     color: "#fff",
//                     px: 4,
//                     py: 3,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 2,
//                     fontSize: "20px",
//                     fontWeight: 700,
//                 }}
//             >
//                 <Box
//                     sx={{
//                         width: 56,
//                         height: 56,
//                         borderRadius: "16px",
//                         background: "rgba(255,255,255,0.12)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                     }}
//                 >
//                     <ShieldOutlinedIcon sx={{ fontSize: 30 }} />
//                 </Box>

//                 Enable Landing Gear Grouping?
//             </DialogTitle>

//             {/* Body */}
//             <DialogContent
//                 dividers
//                 sx={{
//                     px: 5,
//                     py: 4,
//                 }}
//             >
//                 <Typography
//                     sx={{
//                         fontSize: "20px",
//                         color: "#4b5b73",
//                         lineHeight: 1.7,
//                         mb: 3,
//                     }}
//                 >
//                     Changing the <b>LG Grouping</b> setting will affect the
//                     following modules for this lease:
//                 </Typography>

//                 <Box
//                     component="ul"
//                     sx={{
//                         pl: 3,
//                         mb: 4,
//                         color: "#586a82",
//                         fontSize: "18px",
//                         lineHeight: 2.2,
//                     }}
//                 >
//                     <li>
//                         Reserve Rates — single grouped LG rate entry with
//                         allocation percentages
//                     </li>
//                     <li>
//                         Utilization — single LG entry; system auto-creates 3 DB
//                         records
//                     </li>
//                     <li>
//                         Invoices — single LG line item; amount distributed per
//                         allocation % in backend
//                     </li>
//                 </Box>

//                 {/* Warning Box */}
//                 <Box
//                     sx={{
//                         border: "1px solid #f1cf62",
//                         background: "#fff9e8",
//                         borderRadius: "14px",
//                         px: 3,
//                         py: 2.5,
//                         display: "flex",
//                         alignItems: "flex-start",
//                         gap: 1.5,
//                     }}
//                 >
//                     <WarningAmberOutlinedIcon
//                         sx={{
//                             color: "#8a6500",
//                             mt: "2px",
//                         }}
//                     />

//                     <Typography
//                         sx={{
//                             color: "#8a6500",
//                             fontSize: "16px",
//                             lineHeight: 1.7,
//                             fontWeight: 500,
//                         }}
//                     >
//                         This change applies to future records only. Existing
//                         utilization and invoice records are not affected.
//                     </Typography>
//                 </Box>
//             </DialogContent>

//             {/* Footer */}
//             <DialogActions
//                 sx={{
//                     px: 4,
//                     py: 3,
//                     borderTop: "1px solid #e7edf5",
//                     justifyContent: "flex-end",
//                     gap: 2,
//                 }}
//             >
//                 <Button
//                     variant="outlined"
//                     onClick={() => {
//                         onToggleModal();
//                         handleItemClicked("Cancel Button");
//                     }}
//                     sx={{
//                         minWidth: 150,
//                         height: 56,
//                         borderRadius: "16px",
//                         fontSize: "18px",
//                         fontWeight: 700,
//                         color: "#4b5b73",
//                         borderColor: "#d4dbe5",
//                         textTransform: "none",
//                     }}
//                 >
//                     Cancel
//                 </Button>

//                 <Button
//                     variant="contained"
//                     onClick={() => {
//                         handleItemClicked("Enable Button");
//                         getResponseBack();
//                     }}
//                     sx={{
//                         minWidth: 330,
//                         height: 56,
//                         borderRadius: "16px",
//                         fontSize: "18px",
//                         fontWeight: 700,
//                         background: "#2f6fab",
//                         textTransform: "none",
//                         "&:hover": {
//                             background: "#255f97",
//                         },
//                     }}
//                 >
//                     {isLoading ? (
//                         <CircularProgress
//                             color="inherit"
//                             size={24}
//                         />
//                     ) : (
//                         "Yes, Enable LG Grouping"
//                     )}
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default LgGroupingCofirmModal;